/**
 * @class FacebookAuthResponse
 * @description Handles Facebook code-based authentication response
 */
export class FacebookAuthResponse {
  #userID;
  #expiresIn;
  #code;
  #grantedScopes;

  /**
   * @param {Object} response - Facebook auth response object
   * @param {string} [response.userID] - Facebook user ID
   * @param {number} [response.expiresIn] - Token expiration time
   * @param {string} [response.code] - Authorization code
   * @param {string} [response.grantedScopes] - Granted permissions
   */
  constructor(response) {
    if (!response || typeof response !== 'object') {
      throw new Error('Invalid Facebook auth response');
    }

    this.#code = response.code;

    Object.freeze(this);
  }

  /**
   * @returns {boolean} True if code exists for token exchange
   */
  isValid() {
    return typeof this.#code === 'string' && this.#code.length > 0;
  }

  getCode() {
    return this.#code;
  }

  toString() {
    return `FacebookAuthResponse { userID: ${this.#userID}, expiresIn: ${this.#expiresIn}, code: ${
      this.#code
    }, grantedScopes: ${this.#grantedScopes} }`;
  }
}
